import React, { useContext } from 'react';
import { Row, Col, Card, Stack, Image } from 'react-bootstrap';
import 'assets/styles/common.scss';
import 'Pages/Admin/Dashboard/dashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import DefaultImage from 'assets/images/Dashboard/defalut-list.svg';
import moment from 'moment';
import Shimmer from 'components/commom/Shimmer';

const DashboardData = () => {
  const { locale } = useContext(LocaleContext);

  const dashboardReducer = useSelector(
    (state) => state?.adminDashboardReducer?.loading
  );

  const adminDashboardDetail = useSelector(
    (state) => state?.adminDashboardReducer?.users?.data
  );

  return (
    <div>
      <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
        <FormattedMessage id="Dashboard" />
      </h2>

      <Row className="mt-3 ">
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Providers" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {dashboardReducer ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      adminDashboardDetail?.all_providers_count
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Patients" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {dashboardReducer ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      adminDashboardDetail?.all_patients_count
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} xl={3} md={6} sm={12}>
          <Card className={locale === 'en' ? 'text-start' : 'text-end'}>
            <Card.Body>
              <div className="flex justify-between">
                <div>
                  <div className="fs-16 fc-292D32 lh-201 family_outfit_regular_400">
                    <FormattedMessage id="Total Appointments" />
                  </div>
                  <div className="pt-8 fs-28 lh-3528 fc-3C3C3C family_outfit_regular_500">
                    {dashboardReducer ? (
                      <Shimmer width="250px" height="20px" marginTop="8px" />
                    ) : (
                      adminDashboardDetail?.total_appointments_count
                    )}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Col sm={12} md={12}>
        <div className="fs-20 pt-32 pb-12 fc-292D32 lh-20 family_outfit_semiBold_600">
          <FormattedMessage id="Appointments Today" />
        </div>
      </Col>

      {adminDashboardDetail?.appointments_today &&
      adminDashboardDetail?.appointments_today.length > 0 ? (
        <>
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Patient & ID" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Provider" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Consultation mode" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Booking ID" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Date & Time" />
              </p>
            </Col>
          </Row>
          <Row className="bc-FFFFFF m-0 p-0">
            {adminDashboardDetail?.appointments_today.map((item, index) => {
              return (
                <Row className="m-0 p-0 flex items-center listAppointment">
                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="flex items-center"
                    >
                      <Image
                        src={
                          item?.patient_details?.profile_image !== ''
                            ? item?.patient_details?.profile_image
                            : DefaultImage
                        }
                        alt={'icon'}
                        style={{
                          height: '40px',
                          width: '40px',
                          borderRadius: '50%',
                        }}
                      />
                      <div>
                        <div className="fs-14 fc-202224 lh-1512 family_outfit_semiBold_600">
                          {item?.patient_details?.patient_name}
                        </div>
                        <div className="fs-12 fc-202224 family_outfit_regular_400 pt-04 lh-1512">
                          {item?.patient_details?.patient_id}
                        </div>
                      </div>
                    </Stack>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="flex items-center"
                    >
                      <Image
                        src={
                          item?.provider_details?.profile_image !== ''
                            ? item?.provider_details?.profile_image
                            : DefaultImage
                        }
                        alt={'icon'}
                        style={{
                          height: '40px',
                          width: '40px',
                          borderRadius: '50%',
                        }}
                      />
                      <div>
                        <div className="fs-14 fc-202224 lh-1512 family_outfit_semiBold_600">
                          {item?.provider_details?.provider_name}
                        </div>
                        <div className="fs-12 fc-202224 family_outfit_regular_400 pt-04 lh-1512">
                          {item?.provider_details?.provider_id}
                        </div>
                      </div>
                    </Stack>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-1512">
                      {item?.consultation_type}
                    </div>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-1512 break-all ...">
                      {item?.booking_id}
                    </div>
                  </Col>
                  <Col md={6} lg={2}>
                    <div className="fs-14 fc-202224 lh-1512 family_outfit_regular_400 break-all ...">
                      {moment(item?.appointment_date_time).format(
                        'DD MMM YYYY'
                      )}
                      <br />
                      <span className="fs-14 fc-202224 lh-1512 family_outfit_regular_400 break-all ...">
                        {moment(item?.appointment_date_time).format('hh:mmA')}
                      </span>
                    </div>
                  </Col>
                </Row>
              );
            })}
          </Row>
        </>
      ) : (
        <Col
          sm={12}
          md={12}
          className="border-1 bColor-EFE3D7 h-132 flex items-center justify-center"
        >
          <div className="text-center">
            <div className="fs-14 lh-201 fc-202224 family_outfit_regular_400 ">
              <FormattedMessage id="You haven’t any appointment today" />
            </div>
          </div>
        </Col>
      )}
    </div>
  );
};

export default DashboardData;
